import React, { FC} from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import JETPlusDefault from '@assets/JETPlus-icon-content-default.svg';
import JETChevronDownDefault from '@assets/JETChevron-icon-content-default.svg';
import JETChevronUpDefault from '@assets/JETChevron-icon-content-default.svg';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import styles from './styles';
import {
  useAccordionActions,
  useAccordionState,
} from '@src/shared/context/accordion';
import { OrderStatus } from '@src/pages/Deliveries/context/orders';
import { useTranslation } from 'react-i18next';
import { trackDeliveryDashboardOnClickAssignAccordionButton, trackDeliveryDashboardOnClickRemoveAccordionButton } from '@src/pages/Deliveries/tracking/delivery-dashboard';
import { useKeycloakUserState } from '@src/shared/context/keycloak-user';
import i18n,{ defaultLang } from '@src/i18n';
import { Typography } from '@material-ui/core';

interface IAccordionWrapper {
  accordionReference: string;
  children: any;
  summaryStatus: OrderStatus;
  summaryData?: any
}

export const AccordionWrapper: FC<IAccordionWrapper> = ({
  children,
  accordionReference,
  summaryStatus,
  summaryData
}) => {
  const classes = styles();
  const { activeAccordionReferance } = useAccordionState();
  const { setActiveAccordion } = useAccordionActions();
  const {t} = useTranslation();
  const { restaurant } = useKeycloakUserState();

  const handleChange = (accordionReference: string) => () => {
    if(accordionReference !== activeAccordionReferance) {
      const commonTrackingData = {
        language: i18n.language || defaultLang,
        country:  restaurant?.country || '',
        orderData: {
          order_action: '',
          order_id: accordionReference,
          order_alcohol: summaryData.hasAlcohol ? true : false ,
          order_hashed: summaryData.hash || ''
        }
      }
      switch (summaryStatus) {
        case OrderStatus.Assigned:
         trackDeliveryDashboardOnClickRemoveAccordionButton({
            ...commonTrackingData,
            orderData:{
              ...commonTrackingData.orderData,
              order_action: 'single order remove reassign open'
            }
        })
        break;
        case OrderStatus.AssignedToNextPool:
          break ;
        case OrderStatus.Unassigned:
          trackDeliveryDashboardOnClickAssignAccordionButton(
            {
              ...commonTrackingData,
              orderData:{
                ...commonTrackingData.orderData,              
                order_action: 'single order assign open'
              }
          }
          )
          break;
      }
    }
    setActiveAccordion(
      accordionReference === activeAccordionReferance ? '' : accordionReference
    );
  };

  const getIconBasedOnStatus = (status: OrderStatus) => {
    if (status === OrderStatus.Assigned) {
      return <img src={JETChevronDownDefault} alt="image" />;
    }
    return <img src={JETPlusDefault} alt="image" />;
  };

  

  return (
    <div className={classes.root}>
               
      <Accordion
        expanded={activeAccordionReferance === accordionReference}
        onChange={handleChange(accordionReference)}
        TransitionProps={{ unmountOnExit: true }}
      >
        <AccordionSummary
          expandIcon={
            activeAccordionReferance === accordionReference ? (
              <img src={JETChevronUpDefault} alt="image" />
            ) : (
              getIconBasedOnStatus(summaryStatus)
            )
          }
          aria-controls={accordionReference}
          id={accordionReference}
        >
          {summaryStatus === OrderStatus.Assigned || summaryStatus === OrderStatus.AssignedToNextPool
            ? <Typography variant="body1" className='body_small_bold'>{t('order.accordion_remove')}</Typography>
            :<Typography variant="body1" className='body_small_bold'>{ t('order.accordion_assign')}</Typography>}
        </AccordionSummary>
        <AccordionDetails>{children}</AccordionDetails>
      </Accordion>
    </div>
  );
};

export default AccordionWrapper;
